import React from 'react';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../../constants';

import SvgComponent from '../../../SvgComponent';

class PaymentAccountLegendComponent extends React.Component {
    render() {
        const { i18n } = this.props;

        return (
            <section className="legends" aria-labelledby="payments-legend-title">
                <h2 id="payments-legend-title" className="sr-only">
                    {i18n.LEGEND_TITLE}
                </h2>
                <div className="legend flex-container-v">
                    <div className="label flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/icon/picto-check.svg`}
                            width={20}
                            height={20}
                            aria-hidden="true"
                            focusable="false"
                        />
                        <p>
                            <span>{i18n.STATES.PAID}</span> : {i18n.LEGEND.VALID_MESSAGE}
                        </p>
                    </div>
                    <div className="label flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/icon/picto-pending.svg`}
                            width={20}
                            height={20}
                            aria-hidden="true"
                            focusable="false"
                        />
                        <p>
                            <span>{i18n.STATES.WAITING}</span> : {i18n.LEGEND.WAITING_MESSAGE}
                        </p>
                    </div>
                </div>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.PAYMENTS
    };
}

export default connect(mapStateToProps)(PaymentAccountLegendComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/payment/PaymentAccountLegendComponent.js